import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CameraEvnetById, deleteEventApi } from "../api/api";
import { LuCamera } from "react-icons/lu";
import { FaEdit, FaTrash } from "react-icons/fa";
import { BsThreeDots } from "react-icons/bs";
import { SkeletonCard } from "../context/Customfunction";
import { toast } from "react-toastify";

function CameraEventById() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setevent] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cmaeraDetail, setCameraDetail] = useState([]);
  console.log("cmaeraDetail", cmaeraDetail);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const data = await CameraEvnetById(id);
      if (data?.data?.status === true) {
        setevent(data?.data?.data);
        setCameraDetail(data?.data?.data[0]?.cameras);
      }
    } catch (error) {
      console.error("Error fetching use cases:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleEdit = (eventId) => {
    // Navigate or open modal for editing
    navigate(`/edit-event/${eventId}`);
  };

  const handleDelete = async (eventId) => {
    try {
      const data = await deleteEventApi(eventId);
      if (data) {
        toast("Event deleted!!");
        fetchEvents();
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  return (
    <div>
      <aside className="mainSection">
        <div className="mb-5 pb-5 border-bottom">
          <div className="topEventFilter py-3 px-4"></div>

          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="m-0 ">All Events ({event?.length})</h3>

              <div className="d-flex align-items-center gap-3">
                <button className="transParent3 p-2">Select</button>
                <button
                  onClick={() => {
                    navigate("/create-new-event");

                    localStorage.setItem(
                      "Camera_ids",
                      JSON.stringify(cmaeraDetail)
                    );
                  }}
                  className="mainBlue3 p-2"
                >
                  + New Event
                </button>
              </div>
            </div>
          </div>

          <div className="px-4">
            <div className="allEventsItems">
              {loading
                ? // Show 4 skeletons
                  Array.from({ length: 4 }).map((_, index) => (
                    <SkeletonCard key={index} />
                  ))
                : event &&
                  event.map((ele) => (
                    <div
                      key={ele._id}
                      className="itemsBox"
                      onClick={(e) => {
                        const selection = window.getSelection();
                        if (!selection || selection.toString().length === 0) {
                          navigate(
                            `/usecase-events-logs/${
                              ele?.cameras[0]?.camera_id
                            }/${encodeURIComponent(ele?.event_type_name)}`
                          );
                        }
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="ident">{ele?.event_type_name}</span>

                        <div
                          className="position-relative"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenMenuId(
                              openMenuId === ele._id ? null : ele._id
                            );
                          }}
                        >
                          <BsThreeDots
                            size={24}
                            style={{ cursor: "pointer" }}
                          />

                          {openMenuId === ele._id && (
                            <div
                              className="dropdown-menu show p-2"
                              style={{
                                position: "absolute",
                                right: 0,
                                top: "30px",
                                zIndex: 100,
                                minWidth: "120px",
                                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                                backgroundColor: "#fff",
                                borderRadius: "4px",
                              }}
                            >
                              <div
                                className="dropdown-item d-flex align-items-center gap-2"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEdit(ele._id)}
                              >
                                <FaEdit /> Edit
                              </div>
                              <div
                                className="dropdown-item d-flex align-items-center gap-2"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDelete(ele._id)}
                              >
                                <FaTrash /> Delete
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <h3 className="my-3">Event Name - {ele?.event_name}</h3>

                      <p className="contIcon mb-2">
                        <span className="selectIcon">
                          <LuCamera size={18} />
                        </span>
                        {ele?.cameras[0]?.camera_name}
                      </p>
                    </div>
                  ))}
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}

export default CameraEventById;
